"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[481],{

/***/ 40070:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "b": function() { return /* binding */ useTaggingClick; },
  "q": function() { return /* binding */ useTaggingLoad; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./components/common/commonUtil.ts
var commonUtil = __webpack_require__(2576);
// EXTERNAL MODULE: ./components/common/constants.ts
var constants = __webpack_require__(23234);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
;// CONCATENATED MODULE: ./components/common/tagging/taggingCommon.ts




// eslint-disable-next-line @typescript-eslint/no-var-requires
var utc = __webpack_require__(70178);
/** braze 일정데이터 포맷 */ var formatForTagging = function(dateString, timeString) {
    var dayDiff = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    dayjs_min_default().extend(utc);
    return dayjs_min_default()("".concat(dateString).concat(timeString !== null && timeString !== void 0 ? timeString : ""), "YYYYMMDDHHmm").add(dayDiff, "day")// eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    .utc(true).toISOString();
};
var getTaggingData = function(key) {
    var tagging = window.tagging || {};
    var _key;
    return key ? (_key = tagging[key]) !== null && _key !== void 0 ? _key : null : tagging;
};
var setTaggingData = function(key, value) {
    if (!key || !value) return;
    window.tagging = window.tagging || {};
    window.tagging[key] = value;
};
/** global 데이터 */ var menuForTagging = function(paramDspSid) {
    try {
        var queryParams = (0,commonUtil/* getQueryParams */.vl)();
        var queryDspSid = paramDspSid || (queryParams === null || queryParams === void 0 ? void 0 : queryParams.dspSid) || "";
        var globalMenuFetch = getTaggingData("useGlobalMenuBFF");
        var globalMenu = (0,_to_consumable_array/* default */.Z)(globalMenuFetch.menuLv1List).concat((0,_to_consumable_array/* default */.Z)(globalMenuFetch.menuLv2List), (0,_to_consumable_array/* default */.Z)(globalMenuFetch.menuLv3List));
        var menu = {
            dspNm: "-",
            dspMenu: "-",
            dspSid: "-"
        };
        var ref;
        // queryDspSid lv4 -> lv3 변환
        menu = (ref = globalMenu.find(function(e) {
            return e.dspSid === "".concat(queryDspSid.slice(0, -2), "00");
        })) !== null && ref !== void 0 ? ref : {
            dspNm: "-",
            dspMenu: "-",
            dspSid: "-"
        };
        var tmp = menu.dspNm, dspSidNm = tmp === void 0 ? "-" : tmp, tmp1 = menu.dspMenu, dspMenuCd = tmp1 === void 0 ? "-" : tmp1, tmp2 = menu.dspSid, dspSidCd = tmp2 === void 0 ? "-" : tmp2;
        var dspMenuNm = constants/* commonMainMenu */.uk[dspMenuCd] || "-";
        return {
            dspMenuCd: dspMenuCd,
            dspMenuNm: dspMenuNm,
            dspSidCd: dspSidCd,
            dspSidNm: dspSidNm
        };
    } catch (error) {
        return null;
    }
};
/** ```
 * amplitude -
 * 		pkg_select_promo_calender
 *  	pkg_select_promo_locallist
 * 		pkg_select_promo_dtl
 * 기획전 배너 클릭 공용
 * selectDiv: "localListFilter" |
 * ```*/ var taggingClickBanner = function(contents) {
    try {
        var title = contents.title, link = contents.link, _selectDiv = contents.selectDiv, selectDiv = _selectDiv === void 0 ? "-" : _selectDiv;
        var queryParams = (0,commonUtil/* getQueryParams */.vl)(link.split("?")[1]);
        return {
            selectDiv: selectDiv,
            promoNm: title,
            promoCd: (queryParams === null || queryParams === void 0 ? void 0 : queryParams.mstNo) || "-",
            promoLink: link
        };
    } catch (e) {
        return null;
    }
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./components/common/eventUtil.ts
var eventUtil = __webpack_require__(99346);
// EXTERNAL MODULE: ./components/common/goodsUtil.ts
var goodsUtil = __webpack_require__(68284);
;// CONCATENATED MODULE: ./components/common/tagging/taggingDetailPackage.ts








/** 상세 데이터 */ var detailForTagging = function(eventDetail) {
    try {
        var menuData = menuForTagging();
        var queryParams = (0,commonUtil/* getQueryParams */.vl)();
        var queryEvCd = queryParams === null || queryParams === void 0 ? void 0 : queryParams.evCd;
        var evCd = eventDetail.evCd, evNm = eventDetail.evNm, dayCnt = eventDetail.dayCnt, dayStayInfo = eventDetail.dayStayInfo, tourPatInfo = eventDetail.tourPatInfo;
        var continentCd = eventDetail.continentCd, continentNm = eventDetail.continentNm, countryCd = eventDetail.countryCd, countryNm = eventDetail.countryNm;
        var goodsCd = evCd.split("-")[0];
        // USE_EVENT_PRICE
        var useEventPrice = getTaggingData("useEventPrice");
        var totalPrice = (0,eventUtil/* getPrice */.aS)(useEventPrice);
        var ref, ref1, ref2;
        var price = {
            adtPrice: (ref = useEventPrice === null || useEventPrice === void 0 ? void 0 : useEventPrice.adtPrice) !== null && ref !== void 0 ? ref : 0,
            chdPrice: (ref1 = useEventPrice === null || useEventPrice === void 0 ? void 0 : useEventPrice.chdPrice) !== null && ref1 !== void 0 ? ref1 : 0,
            infPrice: (ref2 = useEventPrice === null || useEventPrice === void 0 ? void 0 : useEventPrice.infPrice) !== null && ref2 !== void 0 ? ref2 : 0
        };
        // USE_EVENT_MILEAGE
        var useEventMileage = getTaggingData("useEventMileage");
        var mileage = (0,goodsUtil/* getExpectMileage */.bd)(useEventMileage);
        var evStartDt = eventDetail.evStartDt, outDeprtTm = eventDetail.outDeprtTm, outArrvTm = eventDetail.outArrvTm, outDayDiff = eventDetail.outDayDiff, evArriveDt = eventDetail.evArriveDt, inDeprtTm = eventDetail.inDeprtTm, inArrvTm = eventDetail.inArrvTm, inDayDiff = eventDetail.inDayDiff;
        var outFlightDeprtTm = formatForTagging(evStartDt, outDeprtTm);
        var outFlightArrvTm = formatForTagging(evStartDt, outArrvTm, outDayDiff);
        var inFlightDeprtTm = formatForTagging(evArriveDt, inDeprtTm, -inDayDiff);
        var inFlightArrvTm = formatForTagging(evArriveDt, inArrvTm);
        var ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14;
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, menuData), {
            prodDiv: queryEvCd ? "evCd" : "goodsCd",
            goodsCd: goodsCd,
            evCd: evCd,
            evNm: evNm,
            continentCd: continentCd,
            continentNm: continentNm,
            countryCd: countryCd,
            countryNm: countryNm,
            propCd: (ref3 = goodsCd.at(2)) !== null && ref3 !== void 0 ? ref3 : "-",
            propNm: (ref5 = constants/* commonTpCd */.S7[(ref4 = goodsCd.at(2)) !== null && ref4 !== void 0 ? ref4 : ""]) !== null && ref5 !== void 0 ? ref5 : "-",
            dayCnt: dayCnt,
            nightCnt: (ref6 = dayStayInfo === null || dayStayInfo === void 0 ? void 0 : dayStayInfo.split("박")[0]) !== null && ref6 !== void 0 ? ref6 : "-",
            tourInfo: tourPatInfo,
            outFlightCd: (ref7 = eventDetail === null || eventDetail === void 0 ? void 0 : eventDetail.outFlightNm) !== null && ref7 !== void 0 ? ref7 : "-",
            outFlightNm: (ref8 = eventDetail === null || eventDetail === void 0 ? void 0 : eventDetail.trCompanyNm) !== null && ref8 !== void 0 ? ref8 : "-",
            outFlightDeprtTm: outFlightDeprtTm !== null && outFlightDeprtTm !== void 0 ? outFlightDeprtTm : "-",
            outFlightArrvTm: outFlightArrvTm !== null && outFlightArrvTm !== void 0 ? outFlightArrvTm : "-",
            inFlightCd: (ref9 = eventDetail === null || eventDetail === void 0 ? void 0 : eventDetail.inFlightNm) !== null && ref9 !== void 0 ? ref9 : "-",
            inFlightNm: (ref10 = eventDetail === null || eventDetail === void 0 ? void 0 : eventDetail.trCompanyNm) !== null && ref10 !== void 0 ? ref10 : "-",
            inFlightDeprtTm: inFlightDeprtTm !== null && inFlightDeprtTm !== void 0 ? inFlightDeprtTm : "-",
            inFlightArrvTm: inFlightArrvTm !== null && inFlightArrvTm !== void 0 ? inFlightArrvTm : "-",
            progCd: (ref11 = eventDetail === null || eventDetail === void 0 ? void 0 : eventDetail.evProgDivi) !== null && ref11 !== void 0 ? ref11 : "-",
            progNm: (ref12 = eventDetail === null || eventDetail === void 0 ? void 0 : eventDetail.evProgDiviNm) !== null && ref12 !== void 0 ? ref12 : "-",
            recCd: (ref13 = eventDetail === null || eventDetail === void 0 ? void 0 : eventDetail.eventTypeCd) !== null && ref13 !== void 0 ? ref13 : "-",
            recNm: (ref14 = constants/* commonEventTypeCd */.Kr[eventDetail === null || eventDetail === void 0 ? void 0 : eventDetail.eventTypeCd]) !== null && ref14 !== void 0 ? ref14 : "-",
            adultPrice: price.adtPrice,
            childPrice: price.chdPrice,
            infantPrice: price.infPrice,
            adultSalePrice: totalPrice.adult,
            childSalePrice: totalPrice.child,
            infantSalePrice: totalPrice.infant,
            expectPoint: mileage
        });
    } catch (error) {
        return null;
    }
};
/**
 * braze, ampliture - pkg_view_dtl
 * @description 행사상세 로드
 */ var taggingLoadDetailPackage = function(eventDetail) {
    try {
        var detail = detailForTagging(eventDetail);
        var dspMenuCd = detail.dspMenuCd, dspMenuNm = detail.dspMenuNm, dspSidCd = detail.dspSidCd, dspSidNm = detail.dspSidNm, progNm = detail.progNm, evCd = detail.evCd;
        var continentNm = detail.continentNm, countryNm = detail.countryNm, outFlightNm = detail.outFlightNm, outFlightDeprtTm = detail.outFlightDeprtTm, inFlightArrvTm = detail.inFlightArrvTm;
        return {
            data: detail,
            attribute: {
                date: dayjs_min_default()().format("YYYYMMDDHHmmss"),
                dspMenuCd: dspMenuCd,
                dspMenuNm: dspMenuNm,
                dspSidCd: dspSidCd,
                dspSidNm: dspSidNm,
                evCd: evCd,
                continentNm: continentNm,
                countryNm: countryNm,
                outFlightNm: outFlightNm,
                outFlightDeprtTm: outFlightDeprtTm,
                inFlightArrvTm: inFlightArrvTm,
                progNm: progNm
            }
        };
    } catch (e) {
        return {
            data: null,
            attribute: null
        };
    }
};
/**
 * ampliture - pkg_select_dtl_change
 * @description [출발일 변경] 버튼 클릭
 */ var taggingClickEventListPopup = function(eventDetail) {
    try {
        var detail = detailForTagging(eventDetail);
        return detail;
    } catch (error) {
        return null;
    }
};
/**
 * braze, ampliture - goods_down_coupon
 * @description 사용가능쿠폰 內 [다운로드] 버튼 클릭 -> 행사상세 중단 & 쿠폰적용 모달
 */ var taggingClickCouponDown = function(coupon) {
    try {
        var evCd = coupon.evCd, selectDiv = coupon.selectDiv, couponNm = coupon.couponNm, couponNo = coupon.couponNo, discAmt = coupon.discAmt, discRate = coupon.discRate, validityFrDt = coupon.validityFrDt, validityToDt = coupon.validityToDt;
        return {
            selectDiv: selectDiv,
            evCd: evCd,
            couponCd: couponNo,
            couponNm: couponNm,
            couponValidityFrDt: validityFrDt || "-",
            couponValidityToDt: validityToDt || "-",
            couponDiscRate: discRate || 0,
            couponDiscAmt: discAmt || 0
        };
    } catch (error) {
        return null;
    }
};
/**
 * pkg_share_dtl
 * @description [공유하기] 버튼 클릭 후 -> 공유 채널 / 클릭
 */ var taggingClickShareEvent = function(eventDetail) {
    try {
        var detail = detailForTagging(eventDetail);
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, detail), {
            shareCh: eventDetail.shareCh
        });
    } catch (error) {
        return null;
    }
};
/**
 * 행사코드 찜 선택
 * braze - pkg_add_evCd_wish
 * apmplitude - pkg_select_evCd_wish
 * @description [♡] 버튼 (=위시리스트) / 클릭
 */ var taggingClickEventWish = function(eventDetail) {
    try {
        var detail = detailForTagging(eventDetail);
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, detail), {
            wishYn: eventDetail.wishYn
        });
    } catch (error) {
        return null;
    }
};
/**
 * braze, amplitude
 * 	click	pkg_select_evCd_pkgDtl
 * @description [예약하기] 버튼 클릭
 */ var taggingClickEventReserve = function(props) {
    try {
        var eventDetail = props.eventDetail, count = props.count, _coupon = props.coupon, coupon = _coupon === void 0 ? [] : _coupon;
        var detail = detailForTagging(eventDetail);
        // 쿠폰
        var couponCd = coupon.map(function(c) {
            return c.couponNo;
        }).join(",") || "-";
        var couponNm = coupon.map(function(c) {
            return c.couponNm;
        }).join(",") || "-";
        var couponDiscDivi = coupon.map(function(c) {
            return c.discDiviCd;
        }).join(",") || "-";
        var couponPrice = coupon.map(function(c) {
            return c.calcObj.totalPrice;
        }).join(",") || "-";
        // 인원수, 금액
        var adultCnt = count.adultCnt, childCnt = count.childCnt, infantCnt = count.infantCnt;
        var totalCnt = adultCnt + childCnt + infantCnt;
        var finPrice = detail.adultSalePrice * adultCnt + detail.childSalePrice * childCnt + detail.infantSalePrice * infantCnt;
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, detail), {
            adultCnt: adultCnt,
            childCnt: childCnt,
            infantCnt: infantCnt,
            couponCd: couponCd,
            couponNm: couponNm,
            couponDiscDivi: couponDiscDivi,
            couponPrice: couponPrice,
            finPrice: finPrice,
            totalCnt: totalCnt
        });
    } catch (error) {
        return {};
    }
};

;// CONCATENATED MODULE: ./components/common/tagging/taggingGNB.ts




/**
 * amplitude - gnb_click
 * @description gnb 공통배너 클릭
 */ var taggingClickGNB = function(menu) {
    try {
        var ref = getTaggingData("useGlobalMenuBFF"), menuLv1List = ref.menuLv1List, menuLv2List = ref.menuLv2List, menuLv3List = ref.menuLv3List;
        var globalMenu = (0,_to_consumable_array/* default */.Z)(menuLv1List).concat((0,_to_consumable_array/* default */.Z)(menuLv2List), (0,_to_consumable_array/* default */.Z)(menuLv3List));
        var lv = menu.lv, dspOrder = menu.dspOrder, dspMenu = menu.dspMenu, dspNm = menu.dspNm;
        var defaultData = {
            selectDiv: lv === 0 ? 3 : lv === null || lv === void 0 ? void 0 : lv.toString(),
            menuSeq: dspOrder || 999
        };
        var findMenu = function(sid) {
            return globalMenu.find(function(v) {
                return v.dspSid === sid;
            });
        };
        // LV1
        if (lv === 1) return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultData), {
            dspMenuCd: dspMenu || "-",
            dspMenuNm: dspNm || "-"
        });
        // LV2
        if (lv === 2) {
            var lv1 = findMenu(menu.dspSidHi);
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultData), {
                dspMenuCd: lv1.dspMenu || "-",
                dspMenuNm: lv1.dspNm || "-",
                subDspMenuCd: dspMenu,
                subDspMenuNm: dspNm
            });
        }
        if (lv === 3) {
            var isLocal = lv === 3 && menu.locTypeCd !== "T";
            var isThema = lv === 3 && menu.locTypeCd === "T";
            var lv3 = menu;
            var lv2 = findMenu(menu.dspSidHi);
            var lv11 = findMenu(lv2.dspSidHi);
            var defaultLv3Data = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultData), {
                dspMenuCd: (lv11 === null || lv11 === void 0 ? void 0 : lv11.dspMenu) || "-",
                dspMenuNm: (lv11 === null || lv11 === void 0 ? void 0 : lv11.dspNm) || "-",
                subDspMenuCd: lv2 === null || lv2 === void 0 ? void 0 : lv2.dspMenu,
                subDspMenuNm: lv2 === null || lv2 === void 0 ? void 0 : lv2.dspNm
            });
            // LV3
            if (isLocal) return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultLv3Data), {
                dspSidCd: lv3.dspMenu || "-",
                menuNm: lv3.dspNm || "-"
            });
            // LV3 - 테마
            if (isThema) return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultLv3Data), {
                themeCd: lv3.dspNm || "-",
                themeNm: lv3.dspNm || "-"
            });
        }
        // LV3 - 프로모션
        var isPromotion = menu.subDspTypeCd === "PMO";
        if (isPromotion) {
            var lv31 = menu;
            var lv2ForPromo = findMenu(menu.dspSid);
            var lv1ForPromo = findMenu(lv2ForPromo === null || lv2ForPromo === void 0 ? void 0 : lv2ForPromo.dspSidHi);
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultData), {
                dspMenuCd: (lv1ForPromo === null || lv1ForPromo === void 0 ? void 0 : lv1ForPromo.dspMenu) || "-",
                dspMenuNm: (lv1ForPromo === null || lv1ForPromo === void 0 ? void 0 : lv1ForPromo.dspNm) || "-",
                subDspMenuCd: lv2ForPromo === null || lv2ForPromo === void 0 ? void 0 : lv2ForPromo.dspMenu,
                subDspMenuNm: lv2ForPromo === null || lv2ForPromo === void 0 ? void 0 : lv2ForPromo.dspNm,
                promoNm: lv31.subDspNm || "-",
                promoPcUrl: lv31.dspUrl || "-",
                promoMoUrl: lv31.dspUrl || "-"
            });
        }
    } catch (error) {
        ;
        return null;
    }
};
/**
 * amplitude - pkg_select_icon_main
 * @description GNB 퀵 아이콘 클릭(PC 우측 상단)
 */ var taggingClickGNBIcon = function(option) {
    try {
        return {
            iconSeq: option.menuOrder.toString() || "-",
            pcUrl: option.pcMenuUrl || "-",
            moUrl: option.mobileMenuUrl || "-",
            menuNm_Pc: option.pcMenuNm || "-",
            menuNm_Mo: option.mobileMenuNm || "-"
        };
    } catch (error) {
        return null;
    }
};
/**
 * amplitude - pkg_search_keyword
 * @description GNB 검색바 돋보기 버튼
 */ var taggingClickGNBSearch = function(bannerText) {
    try {
        return {
            selectDiv: "searchBar",
            keyword: bannerText.keyword || "-",
            pcUrl: bannerText.pcUrl || "-",
            moUrl: bannerText.mobileUrl || "-",
            displayStartDt: bannerText.startDt || "-",
            displayEndDt: bannerText.endDt || "-"
        };
    } catch (error) {
        return null;
    }
};

// EXTERNAL MODULE: ./framework/config/public.ts
var config_public = __webpack_require__(32423);
;// CONCATENATED MODULE: ./components/common/tagging/taggingLocalList.ts








/** 필터 데이터 */ var filterForTagging = function() {
    try {
        var queryParams = (0,commonUtil/* getQueryParams */.vl)();
        var filters = null;
        var rawData = sessionStorage.getItem("persist:$$YBSESSION_PRDT_FILTER_".concat(config_public/* default.RUNTIME_ENV */.Z.RUNTIME_ENV));
        if (rawData) {
            var parsedData = JSON.parse(rawData);
            filters = parsedData.goodsFilter ? JSON.parse(parsedData.goodsFilter)[queryParams.dspSid] : null;
        }
        // 정렬 및 필터 정보
        var sortOrderNm = "-";
        var filterDtlSearch = "-";
        var filterDeprtMn = "-";
        var filterDeprtDt = "-";
        var filterDeprtTime = "-";
        var filterDeprtCity = "-";
        var filterNight = "-";
        var filterPriceMin = "-";
        var filterPriceMax = "-";
        var filterFlight = "-";
        var filterFeature = "-";
        var filterPromo = "-";
        var filterMem = "-";
        if (filters) {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18;
            // 정렬
            sortOrderNm = ((ref = filters.find(function(e) {
                return e.key === "sort";
            })) === null || ref === void 0 ? void 0 : ref.text) || "-";
            // 상세검색
            filterDtlSearch = ((ref1 = filters.find(function(e) {
                return e.key === "goodsNm";
            })) === null || ref1 === void 0 ? void 0 : ref1.text) || "-";
            // 출발일정
            var departureDate = (ref2 = filters.find(function(e) {
                return e.key === "outStartDateList";
            })) === null || ref2 === void 0 ? void 0 : ref2.value;
            if (departureDate && departureDate.length === 6) {
                filterDeprtMn = dayjs_min_default()(departureDate).format("YYYY-MM") || "-";
            } else {
                filterDeprtDt = dayjs_min_default()(departureDate).format("YYYY-MM-DD") || "-";
            }
            // 출발시간
            filterDeprtTime = ((ref4 = (ref3 = filters.filter(function(e) {
                return e.key === "outDeprtFgList";
            })) === null || ref3 === void 0 ? void 0 : ref3.map(function(t) {
                return t.text;
            })) === null || ref4 === void 0 ? void 0 : ref4.join(",")) || "-";
            // 출발지
            filterDeprtCity = ((ref6 = (ref5 = filters.filter(function(e) {
                return e.key === "outCityDiviNm";
            })) === null || ref5 === void 0 ? void 0 : ref5.map(function(t) {
                return t.text;
            })) === null || ref6 === void 0 ? void 0 : ref6.join(",")) || "-";
            // 여행기간
            filterNight = ((ref8 = (ref7 = filters.filter(function(e) {
                return e.key === "evDayCntList";
            })) === null || ref7 === void 0 ? void 0 : ref7.map(function(t) {
                return t.text;
            })) === null || ref8 === void 0 ? void 0 : ref8.join(",")) || "-";
            // 최소금액
            filterPriceMin = ((ref9 = filters.find(function(e) {
                return e.key === "minPrice";
            })) === null || ref9 === void 0 ? void 0 : ref9.value) || "-";
            // 최대금액
            filterPriceMax = ((ref10 = filters.find(function(e) {
                return e.key === "maxPrice";
            })) === null || ref10 === void 0 ? void 0 : ref10.value) || "-";
            // 이용교통
            filterFlight = ((ref12 = (ref11 = filters.filter(function(e) {
                return e.key === "airCd";
            })) === null || ref11 === void 0 ? void 0 : ref11.map(function(t) {
                return t.text;
            })) === null || ref12 === void 0 ? void 0 : ref12.join(",")) || "-";
            // 상품특징
            filterFeature = ((ref14 = (ref13 = filters.filter(function(e) {
                return e.key === "goodsFeaturesList";
            })) === null || ref13 === void 0 ? void 0 : ref13.map(function(t) {
                return t.text;
            })) === null || ref14 === void 0 ? void 0 : ref14.join(",")) || "-";
            // 프로모션
            filterPromo = ((ref16 = (ref15 = filters.filter(function(e) {
                return e.key === "goodsPromotion";
            })) === null || ref15 === void 0 ? void 0 : ref15.map(function(t) {
                return t.text;
            })) === null || ref16 === void 0 ? void 0 : ref16.join(",")) || "-";
            // 여행구성원
            filterMem = ((ref18 = (ref17 = filters.filter(function(e) {
                return e.key === "goodsTmember";
            })) === null || ref17 === void 0 ? void 0 : ref17.map(function(t) {
                return t.text;
            })) === null || ref18 === void 0 ? void 0 : ref18.join(",")) || "-";
        }
        return {
            sortOrderNm: sortOrderNm,
            filterDtlSearch: filterDtlSearch,
            filterDeprtMn: filterDeprtMn,
            filterDeprtDt: filterDeprtDt,
            filterDeprtTime: filterDeprtTime,
            filterDeprtCity: filterDeprtCity,
            filterNight: filterNight,
            filterPriceMin: filterPriceMin,
            filterPriceMax: filterPriceMax,
            filterFlight: filterFlight,
            filterFeature: filterFeature,
            filterPromo: filterPromo,
            filterMem: filterMem
        };
    } catch (error) {
        return null;
    }
};
/** ```
 * braze, apmplitude - pkg_view_goodsCdList
 * @description 상품전시 리스트 로드
 * ```*/ var taggingLoadLocalList = function() {
    try {
        var menuData = menuForTagging();
        var goodsByMenu = getTaggingData("useGoodsByMenu");
        var continentCd = "-";
        var continentNm = "-";
        var countryCd = "-";
        var countryNm = "-";
        if (Array.isArray(goodsByMenu)) {
            var goods = goodsByMenu[0];
            continentCd = goods.continentCd;
            continentNm = goods.continentNm;
            countryCd = goods.countryCd;
            countryNm = goods.countryNm;
        }
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, menuData), {
            continentCd: continentCd,
            continentNm: continentNm,
            countryCd: countryCd,
            countryNm: countryNm
        });
    } catch (e) {
        return null;
    }
};
/** ```
 * Braze, Amplitude - 상품 비교 pkg_compare_goodsCd
 * @description 상품 비교 로드
 * ```*/ var taggingLoadCompareGoods = function(compareList) {
    try {
        if (!compareList || !compareList.length) return;
        var menuData = menuForTagging();
        var filterData = filterForTagging();
        var product1 = compareList[0];
        var product2 = compareList[1];
        var product3 = compareList[2];
        // 첫번째 비교상품
        var goodsCdSeq1 = product1.goodsCd;
        var goodsNmSeq1 = product1.goodsNm;
        var countryCdSeq1 = "-";
        var countryNmSeq1 = "-";
        // 두번째 비교상품
        var goodsCdSeq2 = product2.goodsCd;
        var goodsNmSeq2 = product2.goodsNm;
        var countryCdSeq2 = "-";
        var countryNmSeq2 = "-";
        // 세번째 비교상품
        var goodsCdSeq3 = (product3 === null || product3 === void 0 ? void 0 : product3.goodsCd) || "-";
        var goodsNmSeq3 = (product3 === null || product3 === void 0 ? void 0 : product3.goodsNm) || "-";
        var countryCdSeq3 = "-";
        var countryNmSeq3 = "-";
        // USE_GOODS_BY_MENU
        var continentCd = "-";
        var continentNm = "-";
        var goodsByMenu = getTaggingData("useGoodsByMenu");
        if (Array.isArray(goodsByMenu)) {
            var p1 = goodsByMenu.find(function(e) {
                return e.goodsCd === goodsCdSeq1;
            });
            var p2 = goodsByMenu.find(function(e) {
                return e.goodsCd === goodsCdSeq2;
            });
            var p3 = goodsByMenu.find(function(e) {
                return e.goodsCd === goodsCdSeq3;
            });
            // 공통
            continentCd = p1.continentCd;
            continentNm = p1.continentNm;
            // 상품비교 1
            countryCdSeq1 = p1.countryCd;
            countryNmSeq1 = p1.countryNm;
            // 상품비교 2
            countryCdSeq2 = p2.countryCd;
            countryNmSeq2 = p2.countryNm;
            // 상품비교 3 (모바일 해당 X)
            if (p3) {
                countryCdSeq3 = p3.countryCd;
                countryNmSeq3 = p3.countryNm;
            }
        }
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, menuData, filterData), {
            continentCd: continentCd,
            continentNm: continentNm,
            goodsCdSeq1: goodsCdSeq1,
            goodsNmSeq1: goodsNmSeq1,
            countryCdSeq1: countryCdSeq1,
            countryNmSeq1: countryNmSeq1,
            goodsCdSeq2: goodsCdSeq2,
            goodsNmSeq2: goodsNmSeq2,
            countryCdSeq2: countryCdSeq2,
            countryNmSeq2: countryNmSeq2,
            goodsCdSeq3: goodsCdSeq3,
            goodsNmSeq3: goodsNmSeq3,
            countryCdSeq3: countryCdSeq3,
            countryNmSeq3: countryNmSeq3
        });
    } catch (e) {
        return null;
    }
};
/**
 * braze, amplitude - pkg_select_prod_list
 * @description 상품 리스트 상품 클릭 이벤트
 * @param goodsCd string
 */ var taggingClickGoods = function(props) {
    try {
        var ref, ref1, ref2, ref3;
        var goodsCd = props.goodsCd;
        var filterData = filterForTagging();
        var menuData = menuForTagging();
        var goodsByMenu = getTaggingData("useGoodsByMenu");
        var goods = goodsByMenu.find(function(v) {
            return v.goodsCd === goodsCd;
        });
        var goodsNm = goods.goodsNm, continentCd = goods.continentCd, continentNm = goods.continentNm, countryCd = goods.countryCd, countryNm = goods.countryNm, minPrice = goods.minPrice;
        var goodsEmphasisDivi = goods.goodsEmphasisDivi, themaDivi = goods.themaDivi, bestYn = goods.bestYn, rvwAvgScore = goods.rvwAvgScore;
        var goodsPromotion = (goods === null || goods === void 0 ? void 0 : goods.goodsPromotion) ? goods === null || goods === void 0 ? void 0 : (ref = goods.goodsPromotion) === null || ref === void 0 ? void 0 : ref.split(",") : undefined;
        var goodsTmember = (goods === null || goods === void 0 ? void 0 : goods.goodsTmember) ? goods === null || goods === void 0 ? void 0 : (ref1 = goods.goodsTmember) === null || ref1 === void 0 ? void 0 : ref1.split(",") : undefined;
        var featuresDivi = (ref2 = goods.goodsFeaturesDiviList) === null || ref2 === void 0 ? void 0 : ref2.split("|");
        var featuresDiviCds = [];
        var featuresDiviNms = [];
        featuresDivi === null || featuresDivi === void 0 ? void 0 : featuresDivi.forEach(function(f) {
            var nm = f.split(",")[0];
            var cd = f.split(",")[1];
            featuresDiviNms.push(nm);
            featuresDiviCds.push(cd);
        });
        var features = (ref3 = goods.goodsFeaturesList) === null || ref3 === void 0 ? void 0 : ref3.split("|");
        var featuresCds = [];
        var featuresNms = [];
        features === null || features === void 0 ? void 0 : features.forEach(function(f) {
            var nm = f.split(",")[0];
            var cd = f.split(",")[1];
            featuresNms.push(nm);
            featuresCds.push(cd);
        });
        var ref4, _themaDivi;
        return {
            data: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, menuData), {
                continentCd: continentCd,
                continentNm: continentNm,
                goodsCd: goodsCd,
                goodsNm: goodsNm,
                goodsPrice: minPrice !== null && minPrice !== void 0 ? minPrice : "-",
                countryCd: countryCd,
                countryNm: countryNm
            }), filterData), {
                emphasisCd: goodsEmphasisDivi !== null && goodsEmphasisDivi !== void 0 ? goodsEmphasisDivi : "-",
                emphasisNm: (ref4 = (0,goodsUtil/* emphasisCdLabel */.WV)(goodsEmphasisDivi)) !== null && ref4 !== void 0 ? ref4 : "-",
                themaCd: themaDivi !== null && themaDivi !== void 0 ? themaDivi : "-",
                themaNm: (_themaDivi = constants/* commonThemaCd */.UJ[themaDivi]) !== null && _themaDivi !== void 0 ? _themaDivi : "-",
                bestYn: bestYn !== null && bestYn !== void 0 ? bestYn : "N",
                promoCd: Array.isArray(goodsPromotion) ? goodsPromotion[0] : "-",
                promoNm: Array.isArray(goodsPromotion) ? goodsPromotion[1] : "-",
                featuresDivCd: featuresDiviCds.join(",") || "-",
                featuresDivNm: featuresDiviNms.join(",") || "-",
                featuresCd: featuresCds.join(",") || "-",
                featuresNm: featuresNms.join(",") || "-",
                memCd: Array.isArray(goodsTmember) ? goodsTmember[0] : "-",
                memNm: Array.isArray(goodsTmember) ? goodsTmember[1] : "-",
                score: rvwAvgScore
            }),
            attribute: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, menuData), {
                date: dayjs_min_default()().format("YYYYMMDDHHmmss"),
                goodsCd: goodsCd,
                continentNm: continentNm,
                countryNm: countryNm,
                featuresNm: featuresNms.join(","),
                memNm: Array.isArray(goodsTmember) ? goodsTmember[1] : "-",
                score: rvwAvgScore
            })
        };
    } catch (e) {
        return {
            data: null,
            attribute: null
        };
    }
};
/** ```
 * Braze - 상품공유 클릭 이벤트 pkg_share_goodsCd
 * ```*/ var taggingClickShareGoods = function(props) {
    try {
        var parameter = props.parameter, shareCh = props.shareCh;
        var filterData = filterForTagging();
        var menuData = menuForTagging();
        var queryParams = (0,commonUtil/* getQueryParams */.vl)(parameter);
        var goodsCd = queryParams.goodsCd || "-";
        var goodsNm = "-";
        // USE_GOODS_BY_MENU
        var goodsByMenu = getTaggingData("useGoodsByMenu");
        var continentCd = "-";
        var continentNm = "-";
        var countryCd = "-";
        var countryNm = "-";
        if (Array.isArray(goodsByMenu)) {
            var goods = goodsByMenu[0];
            continentCd = goods.continentCd;
            continentNm = goods.continentNm;
            countryCd = goods.countryCd;
            countryNm = goods.countryNm;
        }
        if (goodsCd && Array.isArray(goodsByMenu)) {
            // 공유하기 타겟 상품 찾기
            var goods1 = goodsByMenu.find(function(e) {
                return e.goodsCd === goodsCd;
            });
            goodsNm = (goods1 === null || goods1 === void 0 ? void 0 : goods1.goodsNm) || "-";
        }
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, menuData, filterData), {
            continentCd: continentCd,
            continentNm: continentNm,
            countryCd: countryCd,
            countryNm: countryNm,
            goodsCd: goodsCd,
            goodsNm: goodsNm,
            shareCh: shareCh
        });
    } catch (e) {
        return null;
    }
};

;// CONCATENATED MODULE: ./components/common/tagging/taggingReserve.ts






/** 상세 데이터 */ var reserveForTagging = function(eventDetail) {
    try {
        var evCd = eventDetail.evCd, evNm = eventDetail.evNm, dayCnt = eventDetail.dayCnt, dayStayInfo = eventDetail.dayStayInfo, tourPatInfo = eventDetail.tourPatInfo;
        var continentCd = eventDetail.continentCd, continentNm = eventDetail.continentNm, countryCd = eventDetail.countryCd, countryNm = eventDetail.countryNm;
        var goodsCd = evCd.split("-")[0];
        // USE_EVENT_PRICE
        var useEventPrice = getTaggingData("useEventPrice");
        var totalPrice = (0,eventUtil/* getPrice */.aS)(useEventPrice);
        var ref, ref1, ref2;
        var price = {
            adtPrice: (ref = useEventPrice === null || useEventPrice === void 0 ? void 0 : useEventPrice.adtPrice) !== null && ref !== void 0 ? ref : 0,
            chdPrice: (ref1 = useEventPrice === null || useEventPrice === void 0 ? void 0 : useEventPrice.chdPrice) !== null && ref1 !== void 0 ? ref1 : 0,
            infPrice: (ref2 = useEventPrice === null || useEventPrice === void 0 ? void 0 : useEventPrice.infPrice) !== null && ref2 !== void 0 ? ref2 : 0
        };
        // USE_EVENT_MILEAGE
        var useEventMileage = getTaggingData("useEventMileage") || [];
        var mileage = (0,goodsUtil/* getExpectMileage */.bd)(useEventMileage);
        var evStartDt = eventDetail.evStartDt, outDeprtTm = eventDetail.outDeprtTm, outArrvTm = eventDetail.outArrvTm, outDayDiff = eventDetail.outDayDiff, evArriveDt = eventDetail.evArriveDt, inDeprtTm = eventDetail.inDeprtTm, inArrvTm = eventDetail.inArrvTm, inDayDiff = eventDetail.inDayDiff;
        var outFlightDeprtTm = formatForTagging(evStartDt, outDeprtTm);
        var outFlightArrvTm = formatForTagging(evStartDt, outArrvTm, outDayDiff);
        var inFlightDeprtTm = formatForTagging(evArriveDt, inDeprtTm, -inDayDiff);
        var inFlightArrvTm = formatForTagging(evArriveDt, inArrvTm);
        var ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14;
        return {
            prodDiv: "evCd",
            goodsCd: goodsCd,
            evCd: evCd,
            evNm: evNm,
            continentCd: continentCd,
            continentNm: continentNm,
            countryCd: countryCd,
            countryNm: countryNm,
            propCd: (ref3 = goodsCd.at(2)) !== null && ref3 !== void 0 ? ref3 : "-",
            propNm: (ref5 = constants/* commonTpCd */.S7[(ref4 = goodsCd.at(2)) !== null && ref4 !== void 0 ? ref4 : ""]) !== null && ref5 !== void 0 ? ref5 : "-",
            dayCnt: dayCnt,
            nightCnt: (ref6 = dayStayInfo === null || dayStayInfo === void 0 ? void 0 : dayStayInfo.split("박")[0]) !== null && ref6 !== void 0 ? ref6 : "-",
            tourInfo: tourPatInfo,
            outFlightCd: (ref7 = eventDetail === null || eventDetail === void 0 ? void 0 : eventDetail.outFlightNm) !== null && ref7 !== void 0 ? ref7 : "-",
            outFlightNm: (ref8 = eventDetail === null || eventDetail === void 0 ? void 0 : eventDetail.trCompanyNm) !== null && ref8 !== void 0 ? ref8 : "-",
            outFlightDeprtTm: outFlightDeprtTm !== null && outFlightDeprtTm !== void 0 ? outFlightDeprtTm : "-",
            outFlightArrvTm: outFlightArrvTm !== null && outFlightArrvTm !== void 0 ? outFlightArrvTm : "-",
            inFlightCd: (ref9 = eventDetail === null || eventDetail === void 0 ? void 0 : eventDetail.inFlightNm) !== null && ref9 !== void 0 ? ref9 : "-",
            inFlightNm: (ref10 = eventDetail === null || eventDetail === void 0 ? void 0 : eventDetail.trCompanyNm) !== null && ref10 !== void 0 ? ref10 : "-",
            inFlightDeprtTm: inFlightDeprtTm !== null && inFlightDeprtTm !== void 0 ? inFlightDeprtTm : "-",
            inFlightArrvTm: inFlightArrvTm !== null && inFlightArrvTm !== void 0 ? inFlightArrvTm : "-",
            progCd: (ref11 = eventDetail === null || eventDetail === void 0 ? void 0 : eventDetail.evProgDivi) !== null && ref11 !== void 0 ? ref11 : "-",
            progNm: (ref12 = eventDetail === null || eventDetail === void 0 ? void 0 : eventDetail.evProgDiviNm) !== null && ref12 !== void 0 ? ref12 : "-",
            recCd: (ref13 = eventDetail === null || eventDetail === void 0 ? void 0 : eventDetail.eventTypeCd) !== null && ref13 !== void 0 ? ref13 : "-",
            recNm: (ref14 = constants/* commonEventTypeCd */.Kr[eventDetail === null || eventDetail === void 0 ? void 0 : eventDetail.eventTypeCd]) !== null && ref14 !== void 0 ? ref14 : "-",
            adultPrice: price.adtPrice,
            childPrice: price.chdPrice,
            infantPrice: price.infPrice,
            adultSalePrice: totalPrice.adult,
            childSalePrice: totalPrice.child,
            infantSalePrice: totalPrice.infant,
            expectPoint: mileage
        };
    } catch (error) {
        return null;
    }
};
/**
 * braze, amplitude
 * 	click	pkg_select_evCd_reserve
 * @description [예약하기] 버튼 클릭
 */ var taggingClickReserve = function(props) {
    try {
        var eventDetail = props.eventDetail, count = props.count, _coupon = props.coupon, coupon = _coupon === void 0 ? [] : _coupon;
        var reserve = reserveForTagging(eventDetail);
        // 쿠폰
        var couponCd = coupon.map(function(c) {
            return c.couponNo;
        }).join(",") || "-";
        var couponNm = coupon.map(function(c) {
            return c.couponNm;
        }).join(",") || "-";
        var couponDiscDivi = coupon.map(function(c) {
            return c.discDiviCd;
        }).join(",") || "-";
        var couponPrice = coupon.map(function(c) {
            return c.calcObj.totalPrice;
        }).join(",") || "-";
        // 인원수, 금액
        var adultCnt = count.adultCnt, childCnt = count.childCnt, infantCnt = count.infantCnt;
        var totalCnt = adultCnt + childCnt + infantCnt;
        var finPrice = reserve.adultSalePrice * adultCnt + reserve.childSalePrice * childCnt + reserve.infantSalePrice * infantCnt;
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, reserve), {
            adultCnt: adultCnt,
            childCnt: childCnt,
            infantCnt: infantCnt,
            couponCd: couponCd,
            couponNm: couponNm,
            couponDiscDivi: couponDiscDivi,
            couponPrice: couponPrice,
            finPrice: finPrice,
            totalCnt: totalCnt
        });
    } catch (error) {
        return {};
    }
};
/**
 * braze, amplitude
 *      pkg_booking_complete
 * @description 예약 완료 페이지 LOAD, REVENUE
 */ var taggingLoadReserveComplete = function(props) {
    try {
        var eventDetail = props.eventDetail, reserveDetail = props.reserveDetail;
        var reserve = reserveForTagging(eventDetail);
        // 인원수, 금액
        var adultCnt = reserveDetail.adtCnt, childCnt = reserveDetail.chdCnt, infantCnt = reserveDetail.infCnt, tmp = reserveDetail.discountPrice, couponPrice = tmp === void 0 ? 0 : tmp, rervNo = reserveDetail.rervNo;
        var totalCnt = adultCnt + childCnt + infantCnt;
        var finPrice = reserve.adultSalePrice * adultCnt + reserve.childSalePrice * childCnt + reserve.infantSalePrice * infantCnt;
        return {
            data: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, reserve), {
                adultCnt: adultCnt,
                childCnt: childCnt,
                infantCnt: infantCnt,
                couponPrice: couponPrice,
                finPrice: finPrice,
                totalCnt: totalCnt
            }),
            purchase: {
                productId: rervNo,
                price: finPrice,
                currencyCode: "KRW",
                quantity: totalCnt,
                purchaseProperties: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, reserve), {
                    rervCd: rervNo,
                    adultCnt: adultCnt,
                    childCnt: childCnt,
                    infantCnt: infantCnt,
                    couponPrice: couponPrice,
                    finPrice: finPrice,
                    totalCnt: totalCnt
                })
            },
            revenue: {
                productId: rervNo,
                price: finPrice,
                quantity: totalCnt,
                revenue: finPrice - couponPrice
            }
        };
    } catch (error) {
        return {};
    }
};

// EXTERNAL MODULE: ./framework/utils/logger.ts
var logger = __webpack_require__(42277);
// EXTERNAL MODULE: ./node_modules/@kit/utils/esm/index.mjs + 146 modules
var esm = __webpack_require__(83012);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/modern/QueryClientProvider.js
var QueryClientProvider = __webpack_require__(30202);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./hooks/common/useTagging.ts
/* eslint-disable @typescript-eslint/no-explicit-any */ 










/** 사용할 queryKey */ var taggingQueryKeys = [
    "useGlobalMenuBFF",
    "useGoodsFilter",
    "useGoodsByMenu",
    "useEventPrice",
    "useEventMileage",
    "useSigninUser", 
];
var common = function() {
    return {
        cat: "PKG"
    };
};
var brazeEvent = function(eventName, data) {
    data && esm/* braze.logCustomEvent */.ID.logCustomEvent(eventName, (0,_object_spread/* default */.Z)({}, common(), data));
};
var brazeAttribute = function(eventName, data) {
    data && esm/* braze.addToCustomAttributeArray */.ID.addToCustomAttributeArray(eventName, (0,_object_spread/* default */.Z)({}, common(), data));
};
var brazePurChase = function(data) {
    if (!data || !data.productId || !data.price || !data.quantity) return;
    var productId = data.productId, price = data.price, currencyCode = data.currencyCode, quantity = data.quantity, _purchaseProperties = data.purchaseProperties, purchaseProperties = _purchaseProperties === void 0 ? {} : _purchaseProperties;
    esm/* braze.logPurchase */.ID.logPurchase(productId, price, currencyCode, quantity, purchaseProperties);
};
var amplitudeTrack = function(eventName, data) {
    data && esm/* amplitude.track */.bO.track(eventName, (0,_object_spread/* default */.Z)({}, common(), data));
};
var amplitudeRevenue = function(data) {
    if (!data || !data.productId || !data.price || !data.quantity || !data.revenue) return;
    var productId = data.productId, price = data.price, quantity = data.quantity, revenue = data.revenue;
    esm/* amplitude.Revenue */.bO.Revenue().setProductId(productId).setPrice(price).setQuantity(quantity).setRevenueType("pkg").setRevenue(revenue).send();
};
var tracking = function(props) {
    var taggingName = props.taggingName, event = props.event, track = props.track, attribute = props.attribute, purchase = props.purchase, revenue = props.revenue;
    event && brazeEvent(taggingName, event);
    track && amplitudeTrack(taggingName, track);
    attribute && brazeAttribute(taggingName, attribute);
    purchase && brazePurChase(purchase);
    revenue && amplitudeRevenue(revenue);
};
/**
 * @param queryClient
 * @returns boolean
 * @description taggingQueryKeys에 포함하는 queryClient 패치여부
 * @description window 객체에 세팅된 값과 비교하여 패치된 경우 window 객체에 세팅
 */ var isQueryFetched = function(queryClient) {
    // taggingQueryKeys 포함된 것만 가져오기
    var filteredQueries = queryClient.getQueriesData({}).filter(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 1), queryKey = _param[0];
        return Array.isArray(queryKey) && taggingQueryKeys.includes(queryKey[0]);
    });
    var filteredQueryKeys = filteredQueries.map(function(item) {
        return item[0][0];
    });
    // window 객체에 세팅 됬는지 확인
    var windowKeys = Object.keys(window.tagging);
    var isWindowSet = filteredQueryKeys.toSorted().join() === windowKeys.toSorted().join();
    if (isWindowSet) {
        return isWindowSet;
    }
    // queries 패치 여부
    var isQueriesFetched = filteredQueries.every(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), data = _param[1];
        return data;
    });
    if (isQueriesFetched) {
        // window 객체에 세팅
        filteredQueries.forEach(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), queryKey = _param[0], data = _param[1];
            return setTaggingData(queryKey[0], data.body);
        });
        return isQueriesFetched;
    }
    return false;
};
var useTaggingLoad = function(taggingName, taggingData) {
    try {
        if (!taggingName) return;
        var taggingLoad = function() {
            var handlers = {
                // localList.page
                pkg_view_goodsCdList: function() {
                    var data = taggingLoadLocalList();
                    return {
                        event: data,
                        track: data
                    };
                },
                pkg_compare_goodsCd: function(props) {
                    var data = taggingLoadCompareGoods(props);
                    return {
                        event: data,
                        track: data
                    };
                },
                // detailpackage.page
                pkg_view_dtl: function(props) {
                    var ref = taggingLoadDetailPackage(props), data = ref.data, attribute = ref.attribute;
                    return {
                        event: data,
                        track: data,
                        attribute: attribute
                    };
                },
                // reserveComplete.page
                pkg_booking_complete: function(props) {
                    var ref = taggingLoadReserveComplete(props), data = ref.data, purchase = ref.purchase, revenue = ref.revenue;
                    return {
                        event: data,
                        track: data,
                        purchase: purchase,
                        revenue: revenue
                    };
                }
            };
            if (handlers[taggingName]) {
                var result = handlers[taggingName](taggingData);
                tracking((0,_object_spread/* default */.Z)({
                    taggingName: taggingName
                }, result));
            }
        };
        var queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
        (0,react.useEffect)(function() {
            var intervalId = setInterval(function() {
                var isQuery = isQueryFetched(queryClient);
                if (isQuery) {
                    taggingLoad();
                    clearInterval(intervalId);
                }
            }, 1000);
            return function() {
                if (intervalId) clearInterval(intervalId);
            };
        }, [
            taggingData
        ]);
    } catch (error) {
        logger/* default.error */.Z.error({
            message: "useTaggingLoad"
        });
    }
};
var useTaggingClick = function(taggingName, taggingData) {
    try {
        if (!taggingName) return;
        var taggingClick = function(addData) {
            var mergedData = (0,_object_spread/* default */.Z)({}, taggingData, addData);
            var handlers = {
                // GNB
                gnb_click: function() {
                    return {
                        track: taggingClickGNB(mergedData)
                    };
                },
                pkg_select_icon_main: function() {
                    return {
                        track: taggingClickGNBIcon(mergedData)
                    };
                },
                pkg_search_keyword: function() {
                    return {
                        track: taggingClickGNBSearch(mergedData)
                    };
                },
                // banner
                pkg_select_promo_calender: function() {
                    return {
                        track: taggingClickBanner(mergedData)
                    };
                },
                pkg_select_promo_locallist: function() {
                    return {
                        track: taggingClickBanner(mergedData)
                    };
                },
                pkg_select_promo_dtl: function() {
                    return {
                        track: taggingClickBanner(mergedData)
                    };
                },
                // localList.page
                pkg_select_prod_list: function() {
                    var ref = taggingClickGoods(mergedData), data = ref.data, attribute = ref.attribute;
                    return {
                        event: data,
                        track: data,
                        attribute: attribute
                    };
                },
                pkg_share_goodsCd: function() {
                    var data = taggingClickShareGoods(mergedData);
                    return {
                        event: data,
                        track: data
                    };
                },
                // detailPackage.page
                pkg_select_dtl_change: function() {
                    var data = taggingClickEventListPopup(mergedData);
                    return {
                        event: data,
                        track: data
                    };
                },
                goods_down_coupon: function() {
                    var data = taggingClickCouponDown(mergedData);
                    return {
                        event: data,
                        track: data
                    };
                },
                pkg_share_dtl: function() {
                    var data = taggingClickShareEvent(mergedData);
                    return {
                        event: data,
                        track: data
                    };
                },
                pkg_select_evCd_wish: function() {
                    var data = taggingClickEventWish(mergedData);
                    return {
                        event: data,
                        track: data
                    };
                },
                pkg_select_evCd_pkgDtl: function() {
                    var data = taggingClickEventReserve(mergedData);
                    return {
                        event: data,
                        track: data
                    };
                },
                // reserve.page
                pkg_select_evCd_reserve: function() {
                    return {
                        track: taggingClickReserve(mergedData)
                    };
                }
            };
            if (handlers[taggingName]) {
                var result = handlers[taggingName](taggingData);
                tracking((0,_object_spread/* default */.Z)({
                    taggingName: taggingName
                }, result));
            }
        };
        var queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
        (0,react.useEffect)(function() {
            var intervalId = setInterval(function() {
                var isQuery = isQueryFetched(queryClient);
                if (isQuery) clearInterval(intervalId);
            }, 1000);
        }, []);
        return {
            taggingClick: taggingClick
        };
    } catch (error) {
        logger/* default.error */.Z.error({
            message: "useTaggingClick"
        });
        return {
            taggingClick: function() {
                return null;
            }
        };
    }
};


/***/ }),

/***/ 98653:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export globalMenuAsync */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32423);
/* harmony import */ var _FRAMEWORK_utils_logger__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42277);
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21741);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87633);





var key = "useGlobalMenuBFF";
var getPath = function() {
    return "/bff/global/menu";
};
var defaultData = {
    dspTypeCd: "A",
    dspSid: "A000000",
    level: "1,2,3"
};
/** ```
 * 공통메뉴정보 BFF
 *   `/bff/global/menu`
 * ```*/ var globalMenuAsync = function() {
    var params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultData;
    return useConfigureAxios({
        url: "".concat(publicRuntimeConfig.ENV_PRODUCT_URL).concat(getPath()),
        params: params
    });
};
/**
 * @description 공통메뉴정보 BFF
 */ var useGlobalMenu = function() {
    var params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultData, options = arguments.length > 1 ? arguments[1] : void 0;
    try {
        return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__/* .useQuery */ .a)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            queryKey: [
                key,
                JSON.stringify(params)
            ],
            queryFn: function() {
                return (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(getPath(), {
                    params: params
                }).then(function(r) {
                    return r.data;
                });
            },
            staleTime: Infinity,
            gcTime: Infinity,
            throwOnError: true,
            placeholderData: {
                body: {
                    menuLv1List: [],
                    menuLv2List: [],
                    menuLv3List: [],
                    menuLv4List: [],
                    pmoMenuList: [],
                    subMenuList: []
                }
            }
        }, options));
    } catch (error) {
        _FRAMEWORK_utils_logger__WEBPACK_IMPORTED_MODULE_1__/* ["default"].error */ .Z.error(error);
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (useGlobalMenu);



/***/ })

}]);